import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const BusinessCreditTooltip = () => {
  return (
    <Box>
      <Typography component={'div'} variant={'body2'} sx={{ marginBottom: '22px' }} color={'white'}>
        Business Credit Scores predict the likelihood your business will pay its bills. A higher score indicates that
        your business is more likely to pay bills or debts on time.
      </Typography>
      <Typography component={'div'} variant={'body2'} color={'white'}>
        Business Credit Scores can be used to:​
        <ul>
          <li>Get your business approved by creditors and lenders for financing and credit.</li> ​
          <li>Determine the amount of financing, rates and payment terms your business is eligible for.</li>
        </ul>
        ​
      </Typography>
      <Typography component={'div'} variant={'body2'} color={'white'}>
        Read more at{' '}
        <Link
          href="https://consumer.ftc.gov/articles/free-credit-reports"
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}
        >
          <Typography component="span" variant="button2" color="white">
            FTC.GOV
          </Typography>
        </Link>
        &nbsp; You have the right to a free credit report from{' '}
        <Link
          href="https://www.annualcreditreport.com/index.action"
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}
        >
          <Typography component="span" variant="button2" color="white">
            AnnualCreditReport.com
          </Typography>
        </Link>
        &nbsp; or 877-322-8228, the only authorized source under federal law. Take me to the authorized source.
      </Typography>
    </Box>
  )
}

export default BusinessCreditTooltip
